import React from 'react';
import './ProfileCard.css';

interface ProfileCardProps {
  name: string;
  image: string;
  onClick: () => void;
}

// Helper function to format persona names
const formatPersonaName = (name: string): string => {
  switch (name) {
    case 'ai architect':
      return 'AI Architect';
    default:
      return name.charAt(0).toUpperCase() + name.slice(1);
  }
};

const ProfileCard: React.FC<ProfileCardProps> = ({ name, image, onClick }) => {
  return (
    <div className="profile-card" onClick={onClick}>
      <div className="image-container">
        <img src={image} alt={`${name} profile`} className="profile-image" />
      </div>
      <h3 className="profile-name">{formatPersonaName(name)}</h3>
    </div>
  );
};

export default ProfileCard;
